import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReportService } from '../services/report.service';
import { MatSelectChange, MatSelect } from '@angular/material/select';
import { MatIcon } from '@angular/material/icon';
import { MatButtonToggleGroup, MatButtonToggle } from '@angular/material/button-toggle';
import { MatOption } from '@angular/material/core';
import { NgFor } from '@angular/common';
import { MatFormField } from '@angular/material/form-field';
import { FlexModule } from '@angular/flex-layout';

@Component({
    selector: 'order-by',
    templateUrl: './order-by.component.html',
    providers: [ReportService],
    standalone: true,
    imports: [FlexModule, MatFormField, MatSelect, NgFor, MatOption, MatButtonToggleGroup, MatButtonToggle, MatIcon]
})
export class OrderByComponent {
  @Input() columns: any[] = [];
  @Output() orderChanged = new EventEmitter();

  orderCol: any;
  orderDir = 'DESC';

  constructor(private reportService: ReportService) {}

  orderDirectionChanged(event) {
    this.orderDir = event.value;
    this.emitOrder();
  }

  columnChanged(event: MatSelectChange) {
    this.orderCol = event.value;
    this.emitOrder();
  }

  emitOrder() {
    this.orderChanged.emit({ order: this.orderCol, direction: this.orderDir });
  }
}
